import { render, staticRenderFns } from "./NatCam.vue?vue&type=template&id=5c285b03"
import script from "./NatCam.vue?vue&type=script&lang=js"
export * from "./NatCam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports